export default {
  pt: {
    'periodo.label': 'Período',
    'periodo.janela': '{{de}} a {{ate}}',
    'periodo.nenhum': 'Sem período',
  },
  en: {
    'periodo.label': 'Period',
    'periodo.janela': '{{de}} to {{ate}}',
    'periodo.nenhum': 'No period',
  },
  es: {
    'periodo.label': 'Período',
    'periodo.janela': '{{de}} a {{ate}}',
    'periodo.nenhum': 'Sin período',
  },
}
